import React from 'react';
import { Query, Mutation } from 'react-apollo';

import { querySmall } from 'GraphQL/query/MyDepartments.query';
import { mutation } from 'GraphQL/mutation/MyDepartments.mutation';
import { mockExamStudentProfile } from 'GraphQL/query/MockExamManage.query';
import { updateMockExamStudentDepartment } from 'GraphQL/mutation/updateMockExamStudentDepartment';
import { queryMockExamStudentExamCards } from 'GraphQL/query/StudentExam.query';
import DepartmentItem from 'Components/DepartmentItem';

const MAX_FAVS = 10;

const checkFav = (departmentIds = [], deptId) => {
  if (!deptId) return false;
  return departmentIds.find(dId => dId === deptId) !== undefined;
};

const checkCannotAdd = (departmentIds = []) => {
  const result = departmentIds.length >= MAX_FAVS;
  return result;
};

const getToggleList = (departmentList = [], departmentId, isAdded = true) => {
  if (!departmentId) return departmentList;
  const deptIdStr = `${departmentId}`;
  if (isAdded) {
    if (departmentList.indexOf(deptIdStr) >= 0 || departmentList.length >= MAX_FAVS) {
      return departmentList;
    }
    return [...departmentList, deptIdStr];
  } else {
    if (departmentList.indexOf(deptIdStr) < 0) return departmentList;
    return departmentList.filter(deptId => deptId !== deptIdStr);
  }
};

const DepartmentWithFavCheck = props => (
  <Query query={querySmall}>
    {({ loading, error, data, client }) => {
      if (loading) return <DepartmentItem {...props} favLoading={loading} />;
      if (error) return <DepartmentItem {...props} favDisabled />;
      const favList = data ? data.myProfile.myDepartmentIds || [] : [];
      return (
        <Mutation mutation={mutation}>
          {(setMyFavs, { loading: mutationLoading, mutationError: error }) => (
            <Mutation
              mutation={updateMockExamStudentDepartment}
              refetchQueries={[
                { query: mockExamStudentProfile, variables: { roundCode: props.roundCode } },
                { query: queryMockExamStudentExamCards, variables: { roundCode: props.roundCode } },
              ]}
            >
              {(updateStudentDepartment, { loading: mutationLoading, mutationError: error }) => (
                <DepartmentItem
                  {...props}
                  favAdded={checkFav(favList, props.id)}
                  favDisableAdd={data && data.myProfile && checkCannotAdd(favList)}
                  onFavToggle={(id, addedState) => {
                    const newMyFavs = getToggleList(favList, id, !addedState);
                    setMyFavs({ variables: { deptIds: newMyFavs } });
                  }}
                  onUpdateDepartment={departmentId => {
                    updateStudentDepartment({
                      variables: { roundCode: props.roundCode, departmentData: { departmentId } },
                    });
                    props.onClose();
                  }}
                  favLoading={mutationLoading}
                />
              )}
            </Mutation>
          )}
        </Mutation>
      );
    }}
  </Query>
);

export default DepartmentWithFavCheck;
